import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { Observable } from 'rxjs/Observable'
import { HttpClient } from '@angular/common/http'
import { AccountTemplateModel } from '../AccountTemplateModel'

@Injectable()
export class AccountTemplateService {
  private readonly url = environment.base_url + '/v1/account-template'

  constructor(private http: HttpClient) {}

  /**
   *
   * @returns {Observable<Array<AccountTemplateModel>>}
   */
  public list(): Observable<Array<AccountTemplateModel>> {
    return this.http.get<Array<AccountTemplateModel>>(`${this.url}`)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/prospect/services/account-template.service.ts